// Figures the dashboard derives from the latest broker calls.
import type { BrokerCall } from "./api";

const HOUR = 3_600_000;
const DAY = 24 * HOUR;

export function lastDay(calls: BrokerCall[], now = Date.now()): BrokerCall[] {
  return calls.filter((c) => now - c.at < DAY);
}

export function deniedCount(calls: BrokerCall[]): number {
  return calls.filter((c) => c.outcome === "denied").length;
}

/** Calls per hour over the last 12 hours, oldest first, for the sparkline. */
export function hourly(calls: BrokerCall[], now = Date.now()): number[] {
  const buckets = Array.from({ length: 12 }, () => 0);
  for (const c of calls) {
    const h = Math.floor((now - c.at) / HOUR);
    if (h >= 0 && h < 12) buckets[11 - h] = (buckets[11 - h] ?? 0) + 1;
  }
  return buckets;
}
